import { useParams } from "react-router-dom";
import ClientShell from "./ClientShell";
import { useCommercialSummary } from "@/lib/commercialQueries";
import { PackageCard } from "./commercial/PackageCard";
import { PaymentsCard } from "./commercial/PaymentsCard";
import { InvoicesCard } from "./commercial/InvoicesCard";
import { ContractCard } from "./commercial/ContractCard";
import { CoachManagementPanel } from "./commercial/CoachManagementPanel";

/**
 * Master v5 Prompt 14 — Profile Commercial Center. Reachable ONLY from
 * the profile dropdown (`ClientShell`'s menu) — deliberately not a
 * sidebar destination. Every downloadable document here is a private
 * Prompt-11 FileAsset, re-authorized on every download; nothing here
 * ever renders a permanent/cached URL.
 */
export default function CommercialCenterPage() {
  const { workspaceId } = useParams();
  const { data, isPending, isError } = useCommercialSummary(workspaceId);
  const isClientActor = data?.workspace_role === "client_member";

  return (
    <ClientShell>
      <div data-testid="commercial-center-page" className="max-w-3xl">
        <h1 className="font-serif text-2xl text-ink mb-1">Commercial Center</h1>
        <p className="text-sm text-ink-soft mb-4">Your programme, payments, invoices and contract in one place.</p>

        {data?.is_view_as_client && (
          <p className="text-xs bg-mustard/20 text-ink rounded px-3 py-2 mb-4" data-testid="commercial-view-as-client-banner">
            You're viewing as this client — read-only. Payments, signing and change requests are disabled.
          </p>
        )}

        {isPending ? (
          <p className="text-sm text-ink-soft" data-testid="commercial-loading">Loading…</p>
        ) : isError ? (
          <p className="text-sm text-red-600" data-testid="commercial-error">Couldn't load the Commercial Center.</p>
        ) : (
          <div className="space-y-4">
            <PackageCard workspaceId={workspaceId} pkg={data.package} />
            <PaymentsCard workspaceId={workspaceId} payments={data.payments} nextPayment={data.next_payment} isClientActor={isClientActor} />
            <InvoicesCard workspaceId={workspaceId} invoices={data.invoices} isClientActor={isClientActor} />
            <ContractCard
              workspaceId={workspaceId} contracts={data.contracts} currentContractId={data.current_contract_id}
              isClientActor={isClientActor} isViewAsClient={data.is_view_as_client}
            />
            {data.workspace_role === "coach" && !data.is_view_as_client && (
              <CoachManagementPanel workspaceId={workspaceId} pkg={data.package} currentContractId={data.current_contract_id} />
            )}
          </div>
        )}
      </div>
    </ClientShell>
  );
}
